import React from 'react';
import { Box } from '@mui/material';

const G1 = '#9FE870', G2 = '#163300', G3 = '#4caf50', G4 = '#2e7d32', BG = '#f0faf0';
const R = ({ x, y, w, h, fill, rx = 3, opacity = 1, style }) => <rect x={x} y={y} width={w} height={h} rx={rx} fill={fill} opacity={opacity} style={style} />;
const T = ({ x, y, size = 6, fill = G2, weight = 400, opacity = 1, children }) => <text x={x} y={y} fontSize={size} fill={fill} fontWeight={weight} fontFamily="Inter,sans-serif" opacity={opacity}>{children}</text>;

const companies = [
  { name: 'FluxERP Holdings',   revenue: '$248K', profit: '$107K', employees: 48,  color: G1,        active: true  },
  { name: 'FluxERP Trading',    revenue: '$184K', profit: '$72K',  employees: 32,  color: '#60a5fa', active: false },
  { name: 'FluxERP Services',   revenue: '$96K',  profit: '$41K',  employees: 18,  color: '#a78bfa', active: false },
  { name: 'FluxERP Logistics',  revenue: '$62K',  profit: '$18K',  employees: 12,  color: '#f59e0b', active: false },
];

const MultiCompanyMockup = () => {
  const W = 480, H = 300;
  return (
    <Box sx={{ width: '100%', maxWidth: 520, position: 'relative', filter: 'drop-shadow(0 20px 40px rgba(22,51,0,0.20))', '& svg': { display: 'block', width: '100%', height: 'auto' } }}>
      <style>{`@keyframes mfU{from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:translateY(0)}}`}</style>
      <svg viewBox={`0 0 ${W} ${H}`} xmlns="http://www.w3.org/2000/svg">
        <defs><linearGradient id="mg" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="white" stopOpacity="0.06"/><stop offset="100%" stopColor="white" stopOpacity="0"/></linearGradient></defs>
        <R x={0} y={0} w={W} h={H} fill={BG} rx={12} />
        {/* chrome */}
        <R x={0} y={0} w={W} h={26} fill={G2} rx={12} />
        <R x={0} y={14} w={W} h={12} fill={G2} />
        <circle cx={13} cy={13} r={4} fill="#ff5f57" />
        <circle cx={25} cy={13} r={4} fill="#febc2e" />
        <circle cx={37} cy={13} r={4} fill="#28c840" />
        <T x={W/2-36} y={17} size={7} fill={G1} weight={700}>Multi-Company</T>
        {/* sidebar */}
        <R x={0} y={26} w={50} h={H-26} fill={G2} />
        <R x={12} y={34} w={26} h={26} fill={G1} rx={6} />
        <T x={18} y={51} size={9} fill={G2} weight={800}>F</T>
        {[
          { icon: '▦', label: 'Dash',    y: 74  },
          { icon: '⊞', label: 'Companies',y:94, active: true },
          { icon: '◈', label: 'Consol.',  y: 114 },
          { icon: '↔', label: 'Inter-Co', y: 134 },
          { icon: '◉', label: 'Users',    y: 154 },
          { icon: '≡', label: 'Reports',  y: 174 },
        ].map(({ icon, label, y, active }) => (
          <g key={label}>
            {active && <R x={0} y={y-8} w={50} h={20} fill={G1} opacity={0.15} rx={0} />}
            {active && <R x={0} y={y-8} w={3}  h={20} fill={G1} rx={0} />}
            <T x={15} y={y+4}  size={8}   fill={active ? G1 : 'white'} opacity={active ? 1 : 0.4}>{icon}</T>
            <T x={8}  y={y+14} size={4.5} fill={active ? G1 : 'white'} opacity={active ? 1 : 0.3}>{label}</T>
          </g>
        ))}

        {/* topbar */}
        <R x={50} y={26} w={W-50} h={22} fill="white" opacity={0.55} />
        <T x={58} y={41} size={7} fill={G2} weight={700}>Company Management</T>
        <R x={W-82} y={31} w={54} h={12} fill={G1} rx={6} opacity={0.9} />
        <T x={W-78} y={40} size={5.5} fill={G2} weight={700}>+ Add Company</T>

        {/* consolidated stat cards */}
        {[
          { label: 'Total Companies', value: '4',      color: G3,        x: 56  },
          { label: 'Consolidated Rev',value: '$590K',  color: G4,        x: 140 },
          { label: 'Total Profit',    value: '$238K',  color: G3,        x: 224 },
          { label: 'Total Employees', value: '110',    color: G1,        x: 308 },
        ].map(({ label, value, color, x }, i) => (
          <g key={label} style={{ animation: `mfU 0.5s ${0.1+i*0.1}s ease both` }}>
            <R x={x} y={52} w={78} h={38} fill="white" rx={5} />
            <R x={x} y={52} w={3}  h={38} fill={color} rx={2} />
            <T x={x+7} y={64} size={5.5} fill={G2} opacity={0.5}>{label}</T>
            <T x={x+7} y={80} size={9}   fill={G2} weight={700}>{value}</T>
          </g>
        ))}

        {/* company cards */}
        {companies.map(({ name, revenue, profit, employees, color, active }, i) => (
          <g key={name} style={{ animation: `mfU 0.5s ${0.2+i*0.1}s ease both` }}>
            <R x={56} y={96+i*46} w={W-62} h={40} fill="white" rx={6} opacity={active?0.95:0.65} />
            {active && <R x={56} y={96+i*46} w={4} h={40} fill={color} rx={2} />}
            {/* company color dot */}
            <circle cx={72} cy={116+i*46} r={8} fill={color} opacity={active?0.3:0.15} />
            <T x={67} y={120+i*46} size={6} fill={G2} weight={700}>{name.split(' ').map(w=>w[0]).join('').slice(0,2)}</T>
            <T x={86} y={112+i*46} size={6.5} fill={G2} weight={active?700:500}>{name}</T>
            {active && <R x={86} y={116+i*46} w={36} h={10} fill={G1} rx={5} opacity={0.2} />}
            {active && <T x={90} y={124+i*46} size={5} fill={G4} weight={700}>● Active</T>}
            {/* metrics */}
            <T x={220} y={112+i*46} size={5.5} fill={G2} opacity={0.5}>Revenue</T>
            <T x={220} y={124+i*46} size={7}   fill={G2} weight={700}>{revenue}</T>
            <T x={300} y={112+i*46} size={5.5} fill={G2} opacity={0.5}>Net Profit</T>
            <T x={300} y={124+i*46} size={7}   fill={G4} weight={700}>{profit}</T>
            <T x={380} y={112+i*46} size={5.5} fill={G2} opacity={0.5}>Employees</T>
            <T x={380} y={124+i*46} size={7}   fill={G2} weight={700}>{employees}</T>
            {/* switch button */}
            <R x={W-70} y={100+i*46} w={50} h={14} fill={active?G2:BG} rx={7} opacity={active?0.9:0.7} />
            <T x={W-66} y={110+i*46} size={5.5} fill={active?G1:'#64748b'} weight={700}>{active?'● Active':'Switch'}</T>
          </g>
        ))}

        <R x={0} y={0} w={W} h={H} fill="url(#mg)" rx={12} />
      </svg>
      <Box aria-hidden sx={{ position:'absolute', inset:'-1px', borderRadius:'13px', border:'1px solid rgba(22,51,0,0.10)', pointerEvents:'none' }} />
    </Box>
  );
};

export default MultiCompanyMockup;
